import { apiRequest } from './api';

export const getDevices = () =>
  apiRequest('GET', '/devices');

export const getDevice = (id: string) =>
  apiRequest('GET', `/devices/${id}`);

export const createDevice = (data: any) =>
  apiRequest('POST', '/devices', data);

export const updateDevice = (id: string, data: any) =>
  apiRequest('PUT', `/devices/${id}`, data);

export const registerDeviceWithCode = (data: any) =>
  apiRequest('PUT', `/devices/registerdevicewithcode`, data);

export const requestRegistrationCode = (id: string) =>
  apiRequest('GET', `/devices/${id}/requestRegistrationCode`);

export const unregisterDevice = (id: string) =>
  apiRequest('GET', `/devices/${id}/unregister`);

export const deleteDevice = (id: string) =>
  apiRequest('DELETE', `/devices/${id}`);


// Console accessible debug methods available in development mode
if(process.env.NODE_ENV === 'development') {
  window.getDevices = getDevices;
  window.getDevice = getDevice;
  window.createDevice = createDevice;
  window.updateDevice = updateDevice;
  window.registerDeviceWithCode = registerDeviceWithCode;
  window.requestRegistrationCode = requestRegistrationCode;
  window.unregisterDevice = unregisterDevice;
  window.deleteDevice = deleteDevice;
}